import Footer from "@core-components/footer/Footer";
import NavBar from "@core-components/header/NavBar";
import SubHeader from "@core-components/header/SubHeader";
import useAffiliationCode from "@hooks/useAffiliationCode";
import useDevMode from "@hooks/useDevMode";
import useGetUserInformation from "@hooks/useGetUserInformation";
import ErrorPage from "@modules/layout/error/ErrorPage";
import ModalLoader from "@modules/loader/ModalLoader";
import { useBasketStore } from "@modules/order/stores/Basket.store";
import * as Sentry from "@sentry/react";
import React, { useCallback, useEffect } from "react";
import { Outlet, useLocation } from "react-router";

const Layout: React.FC = () => {
  const { setAffiliationCodeInfo } = useBasketStore();
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const location = useLocation();

  // Fetch user information on mount if needed
  useGetUserInformation();

  // Set affiliation code info from URL if present
  const handleChangeAffiliationCode = useCallback(
    (code: string) => {
      setAffiliationCodeInfo({ code, isFilled: true, isValid: false });
    },
    [setAffiliationCodeInfo],
  );

  useAffiliationCode(handleChangeAffiliationCode);

  // Activate dev mode features :
  // - remove tidio chat widget
  useDevMode();

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: -100, behavior: "smooth" });
    }
  }, [location]);

  return (
    <>
      <div className="relative flex h-svh max-h-svh w-screen max-w-screen flex-col">
        <div className="absolute top-0 left-0 z-[99] w-full">
          <NavBar />
        </div>
        <div
          ref={scrollRef}
          className="relative flex-grow overflow-y-auto overflow-x-hidden"
        >
          <Sentry.ErrorBoundary fallback={<ErrorPage />}>
            <SubHeader />
            <Outlet />
            <Footer />
          </Sentry.ErrorBoundary>
        </div>
      </div>
      <ModalLoader />
    </>
  );
};

export default Layout;
